/**
 * AvailabilityTypeItem.jsx
 * Created by Destin Frasier on 03/04/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as AvailabilityType from './AvailabilityType';
import * as AvailabilitySiteType from './AvailabilitySiteType';

export default class AvailabilityTypeExamples extends React.Component {
    render() {
        if (!this.props.legendItems) {
            return (
                <div className="rec-availability-indicators">
                    <AvailabilityType.AvailabilityAvailable />
                    <AvailabilityType.AvailabilityCheckout />
                    <AvailabilityType.AvailabilityWalkUp />
                    <AvailabilityType.AvailabilityLottery />
                    <AvailabilityType.AvailabilityUnavailable />
                </div>
            );
        }
        return (
            <div className="rec-availability-indicators">
                { this.props.legendItems.available &&
                    <AvailabilityType.AvailabilityAvailable />
                }
                { this.props.legendItems.checkout &&
                    <AvailabilityType.AvailabilityCheckout />
                }
                { this.props.legendItems.availableNumber &&
                    <AvailabilityType.AvailabilityAvailableNumber />
                }
                { this.props.legendItems.walkup &&
                    <AvailabilityType.AvailabilityWalkUp />
                }
                { this.props.legendItems.lottery &&
                    <AvailabilityType.AvailabilityLottery />
                }
                { this.props.legendItems.unavailable &&
                    <AvailabilityType.AvailabilityUnavailable />
                }
                { this.props.legendItems.unavailableReserved &&
                    <AvailabilityType.AvailabilityUnavailableReserved />
                }
                { this.props.legendItems.unavailableCross &&
                    <AvailabilityType.AvailabilityUnavailableCross />
                }
                { this.props.legendItems.unavailableBlank &&
                    <AvailabilityType.AvailabilityUnavailableBlank />
                }
                { this.props.legendItems.availableBridged &&
                    <AvailabilityType.AvailabilityBridged />
                }
                { this.props.legendItems.firstComeFirstServed &&
                    <AvailabilityType.AvailabilityFirstComeFirstServed />
                }
                { this.props.legendItems.managementSite &&
                    <AvailabilitySiteType.AvailabilitySiteManagement />
                }
            </div>
        );
    }
}

AvailabilityTypeExamples.propTypes = {
    legendItems: PropTypes.shape({
        available: PropTypes.bool,
        checkout: PropTypes.bool,
        availableNumber: PropTypes.bool,
        walkup: PropTypes.bool,
        lottery: PropTypes.bool,
        unavailable: PropTypes.bool,
        unavailableReserved: PropTypes.bool,
        unavailableCross: PropTypes.bool,
        unavailableBlank: PropTypes.bool,
        availableBridged: PropTypes.bool,
        firstComeFirstServed: PropTypes.bool,
        managementSite: PropTypes.bool
    })
};

AvailabilityTypeExamples.defaultProps = {
    legendItems: {
        available: false,
        checkout: false,
        availableNumber: false,
        walkup: false,
        lottery: false,
        unavailable: false,
        unavailableReserved: false,
        unavailableCross: false,
        unavailableBlank: false,
        availableBridged: false,
        firstComeFirstServed: false,
        managementSite: false
    }
};
